// アプリ発行の認証トークン（/api/check で取得）を保持し、
// /api/files への全リクエストに付与する。
//
// fetch 呼び出しは installAuthInterceptor() で一括してトークンを付与するため、
// 個別の fetch 箇所を修正する必要はない。
// <img> / <video> / <a> の src・href（fetch 以外）は withAuth() でURLを包む。

let authToken: string | null = null;

export const setAuthToken = (t: string | null): void => {
  authToken = t;
};

const appendToken = (url: string): string => {
  if (!authToken) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}t=${encodeURIComponent(authToken)}`;
};

/** メディア要素（img/video/a）の URL にトークンを付与する。 */
export const withAuth = (url: string): string => appendToken(url);

const isFilesApi = (url: string): boolean => url.includes("/api/files");

/** window.fetch をラップし、/api/files 宛リクエストへ自動でトークンを付与する。 */
export const installAuthInterceptor = (): void => {
  const originalFetch = window.fetch.bind(window);

  const wrapped = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    try {
      if (typeof input === "string" && isFilesApi(input)) {
        return originalFetch(appendToken(input), init);
      }
      if (input instanceof Request && isFilesApi(input.url)) {
        return originalFetch(new Request(appendToken(input.url), input), init);
      }
    } catch {
      // 付与に失敗しても元の fetch を実行する
    }
    return originalFetch(input, init);
  };

  window.fetch = wrapped as typeof window.fetch;
};
